import { twMerge } from "tailwind-merge";
import { useIsDark } from "@/context/ThemeContext";
import Image from "next/image";

export default function MiniCard({
  icon,
  heading,
  paragraph,
  cardStyles,
  iconStyles,
  headingStyles,
  paragraphStyles,
}) {
  const isdark = useIsDark();

  return (
    <div
      className={twMerge(
        "flex flex-col items-start rounded-xl bg-section pb-[25px] px-5",
        cardStyles
      )}
      style={{ boxShadow: "4px 4px 10px 0px #0000001A" }}
    >
      <Image
        src={icon}
        alt="icons"
        width={95}
        height={95}
        sizes="(max-width: 1280px) 78px, (max-width: 1920px) 95px, 220px"
        quality={85}
        className={twMerge("w-[78px] xl:w-[110px] 3xl:w-[120px] object-cover", iconStyles)}
      />

      <h1 className={twMerge("font-manrope font-semibold text-[16px] md:text-[20px] xl:text-[22px] laptop:text-2xl 4xl:text-[27px] mt-4 xl:mt-[48px]", !isdark && "bg-gradient-to-r from-[#9C00BB] to-[#1A1A1A] text-transparent bg-clip-text", headingStyles)}>
        {heading}
      </h1>
      {/* gray line */}
      <div className="h-[1px] w-1/2 bg-[#7F7F7F] mt-3 xl:mt-[36px]" />
      <p className={twMerge("font-manrope font-normal text-[14px] md:text-[16px] xl:text-[18px] 4xl:text-[21px] mt-3 xl:mt-[36px] text-[#7F7F7F]", paragraphStyles)}>
        {paragraph}
      </p>
    </div>
  );
};
